module.exports = __webpack_public_path__ + "img/area_19.775bde0b.svg";